module.exports = __webpack_public_path__ + "static/img/icon_new.c6450857.jpg";